import { templateJitUrl } from "@angular/compiler";
import { Pagina } from "../shared/service/generic.service";

    
export class Util {

    static formatCpfCnpj(value: string): string {

        if (!value) return '';
      
        const digits = value.replace(/\D/g, '');
      
        if (digits.length === 11) {
          return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else if (digits.length === 14) {
          return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
      
        return value;
    }

    static formatarValorNumerico(valor: Number) {

        var valorFormatado: String = String(valor);
        var i = 0;

        while ((i = valorFormatado.indexOf(".", i)) != -1) {
            valorFormatado = valorFormatado.replace('.', '');
        }

        valorFormatado = valorFormatado.replace(',', '.');
        return valorFormatado;
    }

    static formatarValorMonetario(valor: Number) {

        var valorFormatado: String = String(valor);
        var i = 0;

        while ((i = valorFormatado.indexOf(".", i)) != -1) {
            valorFormatado = valorFormatado.replace('.', '');
        }

        valorFormatado = valorFormatado.replace(',', '.');
        return valorFormatado;
    }

    static formatarValorComVirgula(valor: Number) {

        var valorFormatado: String = String(valor);
        var i = 0;

        valorFormatado = valorFormatado.replace('.', ',');
        return valorFormatado;
    }
    static formatarValorComPonto(valor: Number) {

        var valorFormatado: String = String(valor);
        var i = 0;

        valorFormatado = valorFormatado.replace(',', '.');
        return valorFormatado;
    }

    static ajustarValoresNulos(valor: any) {

        if (Number.isNaN(valor)) {
            valor = 0
        }
        if (valor == undefined) {
            valor = 0
        }
        if (valor == null) {
            valor = 0
        }
        if (valor == "") {
            valor = 0
        }
        return valor;
    }

    static removerAspas(valor: any) {

        var valorFormatado;
        valorFormatado = valor.replace('""', '');
        valorFormatado = valorFormatado.replace(',', '.');
        valorFormatado = (Number(valorFormatado));

        return valorFormatado;
    }

    static formatarData(date, separator) {
        let d: String = '';
        let m: String = '';
        let newDate = new Date(Date.parse(date));
        let day = Number(`${newDate.getDate()}`);
        let mouth = Number(`${newDate.getMonth() + 1}`);
        let y = String(`${newDate.getFullYear()}`);

        if (day < 10) {
            d = '0' + day;
        } else {
            d = String(day);
        }
        if (mouth < 10) {
            m = '0' + mouth;
        } else {
            m = String(mouth);
        }
        let dateFormatted = d + separator + m + separator + y;
        return dateFormatted;
    }

    static disabledElements(tipo: any) {
        let elements = document.querySelectorAll(tipo);
        let quant = elements.length;
        if (quant > 0) {
            let i = 0;
            while (quant > 0) {
                elements[i].disabled = true;
                i++;
                quant--;
            }
            this.enabledElements(".btnVoltar");
            this.enabledElements(".ng-tns-c1-0"); //botões de modal [sair: sim,não]
        }
    }

    static enabledElements(tipo: any) {
        let elements = document.querySelectorAll(tipo);
        let quant = elements.length;
        if (quant > 0) {
            let i = 0;
            while (quant > 0) {
                elements[i].disabled = false;
                i++;
                quant--;
            }
        }
    }


    static traducaoDataCalendar() {
        let pt_BR: any;
        pt_BR = {
            firstDayOfWeek: 0,
            dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
            monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
            today: 'Hoje',
            clear: 'Limpar'
        }


        return pt_BR;
    }


    static parseDateString(dateString: string): Date | null {

        if (!dateString) {
            console.error("Data inválida fornecida:", dateString);
            return null;
        }
    
        const [day, month, year] = dateString.split('-').map(part => parseInt(part, 10));
    
        if (isNaN(day) || isNaN(month) || isNaN(year)) {
            console.error("Componentes da data inválidos fornecidos:", dateString);
            return null;
        }
    
        const date = new Date(year, month - 1, day);
    
        if (isNaN(date.getTime())) {
            console.error("Data inválida após parsing:", dateString);
            return null;
        }
        
        return date;
    }

    static carregarPesquisaAnterior(tela : string = null) : {retornoDataInicio: string; retornoDataFinal: string, 
                                                             retornoPesquisa: string, retornoPagina: string, 
                                                             retornoTipoPesquisa: string, retornoCancelado: string
                                                             retornoQtdItensPagina: string}{

        let retornoDataInicio: string = sessionStorage.getItem("dataPesquisaInicio");
        let retornoDataFinal: string = sessionStorage.getItem("dataPesquisaFinal");
        let retornoPesquisa: string = sessionStorage.getItem("pesquisa");
        let retornoPagina: string = sessionStorage.getItem("paginaPedidos");
        let retornoTipoPesquisa: string = sessionStorage.getItem("tipoPesquisa");
        let retornoCancelado: string = sessionStorage.getItem("cancelado");
        let retornoQtdItensPagina: string = sessionStorage.getItem("qtdItensPagina");

        if(!retornoDataInicio){
            if(tela){
                let dataInicio = new Date();
                let dataInicioVigente  = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);
                let dataInicioFormatada = this.formatarData(dataInicioVigente, "-")
                retornoDataInicio = dataInicioFormatada;
            }else{
                let dataInicio = new Date();
                let dataInicioFormatada = this.formatarData(dataInicio, "-")
                retornoDataInicio = dataInicioFormatada;
            }
        }

        if(!retornoDataFinal){
            if(tela){
                let dataFinal = new Date();
                let dataFinalVigente  = new Date(dataFinal.getFullYear(), dataFinal.getMonth() + 1, 0);
                let dataFinalFormatada = this.formatarData(dataFinalVigente, "-")
                retornoDataFinal = dataFinalFormatada;
            }else{
                let dataFinal = new Date();
                let dataFinalFormatada = this.formatarData(dataFinal, "-")
                retornoDataFinal = dataFinalFormatada;
            }
        }

        if(!retornoPesquisa) retornoPesquisa = "";

        if(!retornoPagina) retornoPagina = '{"first": 0, "rows": 10}';

        if(!retornoTipoPesquisa) retornoTipoPesquisa = "";

        if(!retornoCancelado) retornoCancelado = "";

        if(!retornoQtdItensPagina) retornoQtdItensPagina = "10";

        return {retornoDataInicio, retornoDataFinal, retornoPesquisa, retornoPagina, retornoTipoPesquisa, retornoCancelado, retornoQtdItensPagina}
    }


    static carregarPesquisaAnteriorComponente() : {retornoPaginaComponente: string}{

        let retornoPaginaComponente: string = sessionStorage.getItem("paginaComponente");

        if(!retornoPaginaComponente) retornoPaginaComponente = '{"first": 0, "rows": 10}';

        return {retornoPaginaComponente}
    }
    
    

    static salvarPesquisaAnterior(dataInicio: string, dataFinal: string, pesquisa: string, pagina: Pagina, tipoPesquisa: string, cancelado: string, qtdItensPagina: string) : void{

        //SALVA DATA INICIO
        if(dataInicio != null || dataInicio != undefined){
            
            sessionStorage.setItem("dataPesquisaInicio", dataInicio);
        } 

        //SALVA DATA FIM
        if(dataFinal != null || dataFinal != undefined){
            
            sessionStorage.setItem("dataPesquisaFinal", dataFinal);
        }

        //SALVA PESQUISA
        if(pesquisa != null || pesquisa != undefined){
            sessionStorage.setItem("pesquisa", pesquisa);
        }

        
        //SALVA PAGINA
        if(pagina != null || pagina != undefined){
            sessionStorage.setItem("paginaPedidos", JSON.stringify(pagina));
        }

        //SALVA TIPO PESQUISA
        if(tipoPesquisa != null || tipoPesquisa != undefined){
            sessionStorage.setItem("tipoPesquisa", tipoPesquisa);
        }

        //SALVA TIPO CANCELADO
        if(cancelado != null || cancelado != undefined){
            sessionStorage.setItem("cancelado", cancelado);
        }

        //SALVA TIPO QUANTIDADE ITENS POR PAGINA
        if(qtdItensPagina != null || qtdItensPagina != undefined){
            sessionStorage.setItem("qtdItensPagina", qtdItensPagina);
        }

    }


    static salvarPesquisaAnteriorComponente(pagina: Pagina) : void{
        //SALVA PAGINA
        if(pagina != null || pagina != undefined){
            sessionStorage.setItem("paginaComponente", JSON.stringify(pagina));
        }
    }


    static formatarBooleano(valor: boolean): string {
        return valor ? 'Sim' : 'Não';
    }

}
